import axiosInstance from "../../lib/axiosInstance";
import { getErrorMessage } from "../../utils/errorUtils";
import {
  setLoadingPayments,
  setPayments,
  setErrorSendingStkPush,
  setLoadingStkPush,
  setStkPushSuccess,
  setErrorLoadingPayments,
  setPaymentPagination,
  setServerResponseStatus,
} from "../slices/payment";
import { toast } from "react-toastify";

export const getPayments =
  ({ page = 1, size = 12, search = "", startDate = "", endDate = "" } = {}) =>
  async (dispatch) => {
    dispatch(setLoadingPayments());
    try {
      const params = { page, size };
      if (search) params.search = search;
      if (startDate) params.startDate = startDate;
      if (endDate) params.endDate = endDate;

      const { data } = await axiosInstance.get("/payments", {
        params,
        headers: { requiresAuth: true },
      });

      if (data.status === "SUCCESS") {
        dispatch(setPayments(data.data.content));
        dispatch(setPaymentPagination(data.data.pagination));
      }
    } catch (error) {
      dispatch(setErrorLoadingPayments(getErrorMessage(error)));
    }
  };

export const sendStkPush = (payload) => async (dispatch) => {
  dispatch(setLoadingStkPush());
  try {
    const { data } = await axiosInstance.post(
      "/payment-integration/stk-push",
      payload,
      {
        headers: { requiresAuth: true },
      },
    );
    if (data.status === "SUCCESS") {
      dispatch(setStkPushSuccess());
      toast.success(data.message || "STK Push sent successfully to customer.");
      dispatch(
        setServerResponseStatus({
          operation: "stk.push",
          status: data.statusCode,
        }),
      );
    }
  } catch (error) {
    const message = getErrorMessage(error);
    toast.error(message);
    dispatch(setErrorSendingStkPush(message));
  }
};

export const resetPaymentServerStatus = () => (dispatch) => {
  dispatch(setServerResponseStatus(null));
};
